const constants = {
  prod: "https://api.textconnect.cdk.com",
  preprod: "https://api.textconnect-preprod.cdk.com",
  nonprod: "https://api-dev.cdktextconnect.com"
};
let url = {
  REACT_APP_FETCH_DETAILS:
    constants[process.env.REACT_APP_NODE_ENV] + "/attachments/signedurl",
  REACT_APP_SAVE_FEEDBACK:
    constants[process.env.REACT_APP_NODE_ENV] + "/attachments/feedback"
};

export default url;
